import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TimesheetPageState } from './states/TimesheetPageState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { CalendarView } from '../../components/molecules/calendar/CalendarView';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { BackButton } from '../../../commonv3/components/atoms/buttons/BackButton';
import { parseQueryParams } from '../../types/location';
import { SessionType } from '../../types/sessions';
import { groupByDate } from '../../../commonv3/types/reservable';
import { DateGroup } from '../../components/molecules/reservable/DateGroup';
import { ScheduleListItem } from '../../components/molecules/reservable/ScheduleListItem';
import './timesheetPositionListPane.module.scss';
import { observable } from 'mobx';
import { TimesheetPositionListState } from './states/TimesheetPositionListState';
import { AttendanceButton } from '../../components/atoms/timesheet/AttendanceButton';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { FlatSelector } from '../../components/molecules/forms/FlatSelector';
import { CoachSkillLabels } from '../../components/molecules/timesheet/CoachSkillLabels';
import { CoachSkillCertificationState } from '../../states/CoachSkillCertificationState';

type Props = {
    pageState: TimesheetPageState;
    coachSkillState: CoachSkillCertificationState;
};

@inject('pageState')
@inject('coachSkillState')
@observer
export class TimesheetPositionListPane extends React.Component<Props> {
    @observable paneState: TimesheetPositionListState = null;
    constructor(props) {
        super(props);
        this.paneState = new TimesheetPositionListState(GlobalStatesV3.currentUser, this.props.pageState);
    }
    async componentDidMount() {
        const { type = SessionType.GROUP_COACHING } = parseQueryParams(GlobalStatesV3.routing.location);
        await this.paneState.init(type);
    }

    render() {
        const {
            selectedSessionType,
            positions,
            startsAt,
            endsAt,
            setSelectedMonth,
            selectedDate,
            setSelectedDate,
            getAttendance,
            setAttendance,
            hasUpdates,
            submit,
            submitState,
            locationTypeOptions,
            selectedLocationType,
            setLocationType,
            filteredByType,
            filteredPositions,
        } = this.paneState;
        const groups = groupByDate(filteredPositions, (r) => r.session.starts_at);
        const skillTypes = this.props.coachSkillState.certificates.getOrElse([]).map((c) => c.type);
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isMobile && <BackButton />}
                <div styleName="pane-title">
                    {selectedSessionType === 'group_coaching' ? 'コーチングのシフト入力' : 'もくもく会のシフト入力'}
                    {selectedSessionType === 'mokumoku' && <CoachSkillLabels types={skillTypes} />}
                </div>
                {positions.loading && <LoaderRow />}
                {!positions.loading && (
                    <div styleName="views">
                        <div styleName="calendar-wrapper">
                            <CalendarView
                                startDate={startsAt}
                                endDate={endsAt}
                                selectedDate={selectedDate}
                                clickables={filteredByType.map((r) => r.session.starts_at)}
                                onClick={setSelectedDate}
                                onMonthChange={setSelectedMonth}
                            />
                        </div>
                        <div styleName="schedule-list-wrapper">
                            {!selectedDate && <div styleName="schedule-list-header">予約する日程を選択</div>}
                            <FlatSelector
                                styleName="location-selector"
                                value={selectedLocationType}
                                options={locationTypeOptions}
                                onChange={setLocationType}
                            />
                            <div styleName="schedule-list-body">
                                {groups.map((group) => (
                                    <DateGroup key={group.date} date={group.date}>
                                        {group.entries.map((entry) => {
                                            return (
                                                <ScheduleListItem
                                                    key={entry.id}
                                                    title={entry.session.template_name}
                                                    reservable={entry.session}
                                                    actionItem={
                                                        <AttendanceButton
                                                            value={getAttendance(entry.id)}
                                                            onChange={(nextValue) => setAttendance(entry.id, nextValue)}
                                                        />
                                                    }
                                                />
                                            );
                                        })}
                                    </DateGroup>
                                ))}
                                <div styleName="button-wrapper">
                                    <Button
                                        styleName="submit-button"
                                        type="primary"
                                        size="m"
                                        loading={submitState.submitting}
                                        disabled={!hasUpdates}
                                        onClick={submit}
                                    >
                                        シフトを確定
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
